module.exports = __webpack_public_path__ + "25ed5a1a0e82b08eb0aa52c964fb5c27.pdf";